var render = function render(){var _vm=this,_c=_vm._self._c;return _c('subsystem-iframe-shell',{attrs:{"external-path":"/project/airConditioningSubsystem","frame-title":"水空调"}})
}
var staticRenderFns = []

export { render, staticRenderFns }